import { render, staticRenderFns } from "./tradeGameRecord.vue?vue&type=template&id=f3950d4c&scoped=true"
import script from "./tradeGameRecord.vue?vue&type=script&lang=js"
export * from "./tradeGameRecord.vue?vue&type=script&lang=js"
import style0 from "./tradeGameRecord.vue?vue&type=style&index=0&id=f3950d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3950d4c",
  null
  
)

export default component.exports